import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DocumentData} from "../types/document-modal.types";
import {baseUrl} from "../../../../constants/base-url";
import {documentResourceType} from "../configs/documents-model-config";
import {DocumentUpdateParams} from "../types/document-update.types";
import {jsonPathHeaders} from "../../../../models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class DocumentModalApiService {
  private http: HttpClient = inject(HttpClient);

  public getDocumentModalData(documentId: number): Observable<DocumentData> {
    return this.http.get<DocumentData>(`${baseUrl}/${documentResourceType.path}/${documentId}`);
  }

  public updateDocumentValue(documentUpdateParams: DocumentUpdateParams): Observable<DocumentData> {
    const { documentId, updateData } = documentUpdateParams;

    return this.http.put<DocumentData>(`${baseUrl}/${documentResourceType.path}/${documentId}`, updateData, {
      headers: jsonPathHeaders
    });
  }
}
